import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NoItemPlaceholderComponent } from './no-item-placeholder.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    NoItemPlaceholderComponent
  ],
  exports: [
    NoItemPlaceholderComponent
  ]
})
export class NoItemPlaceholderModule { }
